<template>
  <div class="detail-page">
    <div class="top-nav">
      <div class="back-btn" @click="$router.go(-1)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </div>
      <h1 class="nav-title">供需详情</h1>
      <div class="nav-placeholder"></div>
    </div>

    <div class="hero-card">
      <div class="hero-top">
        <span class="type-tag" :class="detail.infoType == 1 ? 'supply' : 'demand'">{{ detail.infoType == 1 ? '供应' : '需求' }}</span>
        <span class="time">{{ formatDate(detail.createTime) }}</span>
      </div>
      <h2 class="title">{{ detail.title || '供需信息' }}</h2>
      <div class="meta-row">
<!--        <span>{{ detail.companyName || '联盟成员' }}</span>-->
        <span>{{ detail.addressName || '未知地区' }}</span>
      </div>
      <div class="budget-box">
        <span class="budget-label">{{ detail.infoType == 2 ? '预算' : '报价' }}</span>
        <span class="budget-value">{{ formatBudget(detail) }}</span>
      </div>
    </div>

    <div class="section compact-grid">
      <div class="grid-item">
        <span class="grid-label">类型</span>
        <strong>{{ detail.demandType || '综合' }}</strong>
      </div>
      <div class="grid-item">
        <span class="grid-label">地区</span>
        <strong>{{ detail.addressName || '未知地区' }}</strong>
      </div>
    </div>

    <div class="section">
      <h3 class="section-title">详细描述</h3>
      <div class="content">{{ detail.content || '暂无描述' }}</div>
    </div>

    <div class="section" v-if="detail.imageFileIds && detail.imageFileIds.length">
      <h3 class="section-title">相关图片</h3>
      <div class="image-list">
        <img v-for="(img, index) in detail.imageFileIds" :key="index" :src="img" alt="" @click="openPreview(index)" />
      </div>
    </div>

    <div
      v-if="previewVisible"
      class="preview-mask"
      @click="closePreview"
      @touchstart="handleTouchStart"
      @touchend="handleTouchEnd"
    >
      <div class="preview-header">
        <span>{{ previewIndex + 1 }} / {{ previewImages.length }}</span>
        <button @click.stop="closePreview">关闭</button>
      </div>
      <button class="preview-arrow left" v-if="previewImages.length > 1" @click.stop="prevImage">‹</button>
      <img class="preview-img" :src="previewImages[previewIndex]" alt="" @click.stop />
      <button class="preview-arrow right" v-if="previewImages.length > 1" @click.stop="nextImage">›</button>
    </div>

    <div class="bottom-bar">
      <div class="phone-info">
        <span>联系方式</span>
        <strong>{{ detail.contactDisplayMask || detail.contactTellMask || detail.emailMask || '点击获取' }}</strong>
      </div>
      <button class="contact-btn" @click="handleContact">立即联系</button>
    </div>

    <div class="contact-mask" v-if="contactPanelVisible" @click="closeContactPanel">
      <div class="contact-panel" @click.stop>
        <div class="panel-header">
          <strong>选择联系方式</strong>
          <button @click="closeContactPanel">关闭</button>
        </div>
        <button
          class="contact-option"
          :disabled="!contactInfo.contactTell"
          @click="showPhoneContact"
        >
          <span>电话联系</span>
          <small>{{ contactInfo.contactTellMask || '暂无电话' }}</small>
        </button>
        <button
          class="contact-option"
          :disabled="!contactInfo.email"
          @click="showEmailContact"
        >
          <span>邮箱联系</span>
          <small>{{ contactInfo.emailMask || '暂无邮箱' }}</small>
        </button>
      </div>
    </div>

    <div class="contact-mask" v-if="contactDetailVisible" @click="contactDetailVisible = false">
      <div class="contact-panel" @click.stop>
        <div class="panel-header">
          <strong>{{ contactDetailType === 'phone' ? '电话联系' : '邮箱联系' }}</strong>
          <button @click="contactDetailVisible = false">关闭</button>
        </div>
        <div class="contact-value">{{ contactDetailValue }}</div>
        <div class="panel-actions">
          <button v-if="contactDetailType === 'phone'" class="primary-action" @click="callPhone">拨打电话</button>
          <button v-if="contactDetailType === 'email'" class="primary-action" @click="copyEmail">复制邮箱</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { normalizeMemberInfo } from '@/utils/memberStatus'

export default {
  name: 'SupplyDemandInfo',
  data() {
    return {
      detail: {},
      contactInfo: {},
      contactPanelVisible: false,
      contactDetailVisible: false,
      contactDetailType: '',
      contactDetailValue: '',
      loading: false,
      previewVisible: false,
      previewIndex: 0,
      touchStartX: 0,
      touchStartY: 0
    }
  },
  computed: {
    previewImages() {
      return this.detail.imageFileIds || []
    },
    isEnterpriseMember() {
      const userInfo = normalizeMemberInfo(JSON.parse(sessionStorage.getItem('userInfo') || '{}'))
      return userInfo.memberType === 'ENTERPRISE' && Number(userInfo.companyApplyState) === 1
    }
  },
  mounted() {
    this.getDetail()
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  },
  methods: {
    getDetail() {
      const id = this.$route.params.id
      if (!id) return
      this.loading = true
      this.$ajax.get('/api/supplyDemand/detail', { params: { id } }).then((res) => {
        if (res.data.code == 200) {
          this.detail = res.data.data || {}
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleContact() {
      if (!this.isEnterpriseMember) {
        this.$toast.error('请先加入企业会员')
        return
      }
      if (this.contactInfo.contactTell || this.contactInfo.email) {
        this.contactPanelVisible = true
        return
      }
      this.$ajax.get('/api/supplyDemand/contact', {
        params: { id: this.$route.params.id }
      }).then((res) => {
        if (res.data.code == 200) {
          this.contactInfo = res.data.data || {}
          this.contactPanelVisible = true
        } else {
          this.$toast.error(res.data.message || '获取联系方式失败')
        }
      }).catch(() => {
        this.$toast.error('获取联系方式失败，请稍后重试')
      })
    },
    closeContactPanel() {
      this.contactPanelVisible = false
    },
    showPhoneContact() {
      if (!this.contactInfo.contactTell) return
      this.contactDetailType = 'phone'
      this.contactDetailValue = this.contactInfo.contactTell
      this.contactPanelVisible = false
      this.contactDetailVisible = true
    },
    showEmailContact() {
      if (!this.contactInfo.email) return
      this.contactDetailType = 'email'
      this.contactDetailValue = this.contactInfo.email
      this.contactPanelVisible = false
      this.contactDetailVisible = true
    },
    callPhone() {
      if (this.contactDetailValue) window.location.href = `tel:${this.contactDetailValue}`
    },
    copyEmail() {
      const email = this.contactDetailValue
      if (!email) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(email).then(() => {
          this.$toast.success('邮箱已复制')
        }).catch(() => {
          this.copyEmailFallback(email)
        })
        return
      }
      this.copyEmailFallback(email)
    },
    copyEmailFallback(email) {
      const input = document.createElement('input')
      input.value = email
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$toast.success('邮箱已复制')
    },
    formatDate(time) {
      if (!time) return ''
      return String(time).replace('T', ' ').slice(0, 16)
    },
    formatBudget(item) {
      if (item.budgetMin === -1 || item.budgetMin === null || item.budgetMin === undefined) return '面议'
      if (item.budgetMax === null || item.budgetMax === undefined || item.budgetMax === '') return item.budgetMin
      return `${item.budgetMin}-${item.budgetMax}`
    },
    openPreview(index) {
      this.previewIndex = index
      this.previewVisible = true
      document.body.style.overflow = 'hidden'
    },
    closePreview() {
      this.previewVisible = false
      document.body.style.overflow = ''
    },
    prevImage() {
      if (!this.previewImages.length) return
      this.previewIndex = (this.previewIndex - 1 + this.previewImages.length) % this.previewImages.length
    },
    nextImage() {
      if (!this.previewImages.length) return
      this.previewIndex = (this.previewIndex + 1) % this.previewImages.length
    },
    handleTouchStart(e) {
      const touch = e.touches[0]
      this.touchStartX = touch.clientX
      this.touchStartY = touch.clientY
    },
    handleTouchEnd(e) {
      const touch = e.changedTouches[0]
      const diffX = touch.clientX - this.touchStartX
      const diffY = touch.clientY - this.touchStartY
      if (Math.abs(diffX) < 45 || Math.abs(diffX) < Math.abs(diffY)) return
      diffX > 0 ? this.prevImage() : this.nextImage()
    }
  }
}
</script>

<style scoped>
.detail-page {
  min-height: 100vh;
  padding-bottom: 88px;
  background: #f5f7fa;
  color: #1a1a1a;
  font-size: 12px;
}
.top-nav {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: rgba(255,255,255,0.96);
}
.back-btn,
.nav-placeholder {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-title {
  flex: 1;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
}
.hero-card,
.section {
  margin: 12px 14px;
  padding: 16px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(20, 35, 60, 0.05);
}
.hero-card {
  background: linear-gradient(135deg, #ffffff 0%, #eef5ff 100%);
}
.hero-top,
.meta-row,
.budget-box,
.bottom-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.type-tag {
  padding: 5px 10px;
  border-radius: 999px;
  font-weight: 600;
}
.type-tag.supply {
  color: #0fb864;
  background: #e6ffed;
}
.type-tag.demand {
  color: #fa8c16;
  background: #fff7e6;
}
.time,
.meta-row {
  color: #8a94a6;
}
.title {
  margin: 14px 0 10px;
  font-size: 20px;
  line-height: 1.35;
}
.meta-row {
  justify-content: flex-start;
  gap: 12px;
}
.budget-box {
  margin-top: 16px;
  padding: 12px;
  border-radius: 12px;
  background: #fff;
}
.budget-label,
.grid-label,
.phone-info span {
  color: #8a94a6;
}
.budget-value {
  color: #165DFF;
  font-size: 18px;
  font-weight: 700;
}
.compact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.grid-item {
  padding: 12px;
  border-radius: 12px;
  background: #f8fafc;
}
.grid-label {
  display: block;
  margin-bottom: 6px;
}
.section-title {
  margin: 0 0 12px;
  font-size: 15px;
}
.content {
  white-space: pre-wrap;
  line-height: 1.7;
  color: #333;
}
.image-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.image-list img {
  width: 100%;
  height: 96px;
  border-radius: 10px;
  object-fit: cover;
  cursor: pointer;
}
.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 14px calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -6px 20px rgba(20, 35, 60, 0.08);
}
.phone-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.phone-info strong {
  font-size: 14px;
}
.contact-btn {
  min-width: 132px;
  height: 44px;
  border: none;
  border-radius: 12px;
  background: #165DFF;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
.preview-mask {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.92);
}
.preview-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: calc(14px + env(safe-area-inset-top)) 16px 14px;
  color: #fff;
  font-size: 14px;
}
.preview-header button {
  border: none;
  background: rgba(255,255,255,0.16);
  color: #fff;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 13px;
}
.preview-img {
  max-width: 100%;
  max-height: 82vh;
  object-fit: contain;
}
.preview-arrow {
  position: absolute;
  top: 50%;
  width: 42px;
  height: 58px;
  margin-top: -29px;
  border: none;
  background: rgba(255,255,255,0.12);
  color: #fff;
  font-size: 42px;
  line-height: 1;
}
.preview-arrow.left {
  left: 8px;
}
.preview-arrow.right {
  right: 8px;
}
.contact-mask {
  position: fixed;
  inset: 0;
  z-index: 1001;
  display: flex;
  align-items: flex-end;
  background: rgba(0,0,0,0.45);
}
.contact-panel {
  width: 100%;
  padding: 18px 16px calc(18px + env(safe-area-inset-bottom));
  background: #fff;
  border-radius: 18px 18px 0 0;
  box-shadow: 0 -8px 24px rgba(20, 35, 60, 0.12);
}
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.panel-header strong {
  font-size: 16px;
}
.panel-header button {
  border: none;
  background: #f3f5f8;
  color: #606a78;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
}
.contact-option {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  margin-top: 10px;
  padding: 0 14px;
  border: 1px solid #edf0f5;
  border-radius: 12px;
  background: #fff;
  color: #1a1a1a;
  font-size: 15px;
}
.contact-option small {
  max-width: 58%;
  color: #8a94a6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.contact-option:disabled {
  color: #c0c4cc;
  background: #f7f8fa;
}
.contact-value {
  margin: 16px 0;
  padding: 14px;
  border-radius: 12px;
  background: #f7f8fa;
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  word-break: break-all;
}
.panel-actions {
  display: flex;
  justify-content: flex-end;
}
.primary-action {
  min-width: 120px;
  height: 42px;
  border: none;
  border-radius: 12px;
  background: #165DFF;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/supplyDemandInfo.vue